'use client';

import { ClipboardList } from 'lucide-react';
import { Spinner } from '@paeffgen/react/crm-documents/ui';
import type { MaterialRequest } from '@paeffgen/react/crm-documents/data-access-graphql';
import { useRequestHistory } from './use-request-history';
import { RequestHistoryCard } from './request-history-card';

interface RequestHistoryListProps {
  onReorder: (request: MaterialRequest) => void;
}

export function RequestHistoryList({ onReorder }: RequestHistoryListProps) {
  const { requests, loading } = useRequestHistory();

  if (loading && requests.length === 0) {
    return (
      <div className="flex items-center justify-center py-20">
        <Spinner size="lg" />
      </div>
    );
  }

  if (requests.length === 0) {
    return (
      <div className="max-w-2xl mx-auto text-center py-20">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-zinc-100 mb-5">
          <ClipboardList size={28} className="text-zinc-400" />
        </div>
        <h2 className="text-xl font-bold text-secondary mb-2">Noch keine gesendeten Anfragen</h2>
        <p className="text-text-muted">Sobald Sie eine Anfrage absenden, erscheint sie hier.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {requests.map((r) => (
        <RequestHistoryCard key={r.id} request={r} onReorder={onReorder} />
      ))}
    </div>
  );
}
